'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');

var IconButton = function (props) {
    var Icon = props.icon;
    return (jsxRuntime.jsx("div", { tabIndex: props.tabIndex ? Number(props.tabIndex) : 0, className: "xapp-search-icon-button ".concat(props.className || ""), onClick: props.onClick, children: jsxRuntime.jsx("div", { className: "xapp-search-icon-button__content", children: jsxRuntime.jsx(Icon, {}) }) }));
};

var MessageBubble = function (props) {
    return jsxRuntime.jsx("div", { className: "xappw-message-bubble", children: props.children });
};

// compile time full switch-case verification
function throwBadKind(x) {
    throw new Error("Unknown kind " + x);
}

var RichTextBoldSpan = function (props) {
    var format = props.format, text = props.text;
    return (jsxRuntime.jsx("span", { "data-rich-text-type": "bold", className: "xapp-search-rich-text-bold-span", children: text.substring(format.start, format.end) }));
};

var RichTextInputSpan = function (props) {
    var format = props.format, text = props.text, readOnly = props.readOnly, onClick = props.onClick;
    var defaultValue = format.text || text.substring(format.start, format.end);
    var _a = react.useState(defaultValue), value = _a[0], setValue = _a[1];
    var handleChange = react.useCallback(function (ev) {
        setValue(ev.target.value);
    }, []);
    var handleClick = react.useCallback(function (ev) {
        if (onClick) {
            var res = onClick(format);
            if (res === false) {
                ev.preventDefault();
                ev.stopPropagation();
            }
        }
    }, [onClick, format]);
    if (readOnly) {
        return (jsxRuntime.jsx("span", { className: "xapp-search-rich-text-input-span xapp-search-rich-text-input-span--readonly", onClick: handleClick, children: defaultValue }));
    }
    return (jsxRuntime.jsx("input", { type: "text", value: value, className: "xapp-search-rich-text-input-span", "data-rich-text-type": "inputText", onChange: handleChange, onClick: handleClick, readOnly: readOnly }));
};

var RichTextNormalSpan = function (props) {
    var format = props.format, text = props.text;
    return (jsxRuntime.jsx("span", { "data-rich-text-type": "normal", className: "xapp-search-rich-text-normal-span", children: text.substring(format.start, format.end) }));
};

var RichTextSpan = function (props) {
    var format = props.format, text = props.text, readOnly = props.readOnly, onClick = props.onClick;
    var type = format.type;
    switch (type) {
        case "normal":
            return jsxRuntime.jsx(RichTextNormalSpan, { text: text, format: format, readOnly: readOnly });
        case "bold":
            return jsxRuntime.jsx(RichTextBoldSpan, { text: text, format: format, readOnly: readOnly });
        case "inputText":
            return (jsxRuntime.jsx(RichTextInputSpan, { text: text, format: format, readOnly: readOnly, onClick: onClick }));
        default:
            throwBadKind(type);
    }
};

function cleanRichTextValue(value) {
    var text = value.text, formats = value.formats;
    var newFormats = [];
    for (var _i = 0, formats_1 = formats; _i < formats_1.length; _i++) {
        var format = formats_1[_i];
        var type = format.type;
        switch (type) {
            case "normal":
                continue;
            case "inputText":
                newFormats.push(format);
                break;
            case "bold":
                if (newFormats.length > 0) {
                    var prev = newFormats[newFormats.length - 1];
                    if (prev.type === type && prev.end === format.start) {
                        newFormats.pop();
                        newFormats.push({
                            type: type,
                            start: prev.start,
                            end: format.end
                        });
                    }
                }
                else {
                    newFormats.push(format);
                }
                break;
        }
    }
    return {
        text: text,
        formats: newFormats
    };
}

function extendFormat(formats, length) {
    var res = [];
    var walkerIndex = 0;
    for (var _i = 0, formats_1 = formats; _i < formats_1.length; _i++) {
        var format = formats_1[_i];
        var start = format.start, end = format.end, type = format.type, text = format.text;
        if (walkerIndex < start) {
            res.push({
                type: "normal",
                start: walkerIndex,
                end: start
            });
        }
        res.push({
            type: type,
            start: start,
            end: end,
            text: text
        });
        walkerIndex = end;
    }
    if (walkerIndex < length) {
        res.push({
            type: "normal",
            start: walkerIndex,
            end: length
        });
    }
    return res;
}

function parseContent(node) {
    var children = node.childNodes;
    var formats = [];
    var text = "";
    children.forEach(function (child) {
        if (child.nodeType === Node.ELEMENT_NODE) {
            var node_1 = child;
            var innerText = node_1.tagName === "INPUT" ? node_1.value : node_1.innerText;
            var type = node_1.dataset.richTextType;
            formats.push({
                type: type,
                start: text.length,
                end: text.length + innerText.length,
            });
            text += innerText;
        }
        if (child.nodeType === Node.TEXT_NODE) {
            var node_2 = child;
            var innerText = node_2.nodeValue;
            if (innerText) {
                formats.push({
                    type: "normal",
                    start: text.length,
                    end: text.length + innerText.length,
                });
                text += innerText;
            }
        }
    });
    return cleanRichTextValue({
        text: text,
        formats: formats,
    });
}
function cleanContent(node) {
    var _a;
    var trash = [];
    var raw = node.childNodes;
    for (var i = 0; i < raw.length; i++) {
        var c = raw.item(i);
        if ((c === null || c === void 0 ? void 0 : c.nodeType) === Node.TEXT_NODE) {
            trash.push(c);
        }
    }
    for (var _i = 0, trash_1 = trash; _i < trash_1.length; _i++) {
        var c = trash_1[_i];
        try {
            (_a = c.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(c);
        }
        catch (_b) { }
    }
}
var RichText = function (props) {
    var value = props.value, className = props.className, readOnly = props.readOnly, onInput = props.onInput, onChange = props.onChange, onSpanClick = props.onSpanClick;
    var formatsRaw = value.formats, text = value.text;
    var formats = react.useMemo(function () { return extendFormat(formatsRaw, text.length); }, [formatsRaw, text.length]);
    var handleInput = react.useCallback(function (ev) {
        var target = ev.currentTarget;
        var newValue = parseContent(target);
        if (onInput) {
            onInput(newValue);
        }
    }, [onInput]);
    var handleBlur = react.useCallback(function (ev) {
        var target = ev.currentTarget;
        var newValue = parseContent(target);
        cleanContent(target);
        if (onChange) {
            onChange(newValue);
        }
    }, [onChange]);
    return (jsxRuntime.jsx("div", { id: props.id, className: "xapp-search-rich-text ".concat(className || ""), contentEditable: !readOnly, suppressContentEditableWarning: true, onInput: handleInput, onBlur: handleBlur, onKeyDown: props.onKeyDown, children: formats.map(function (format, index) { return (jsxRuntime.jsx(RichTextSpan, { format: format, text: text, readOnly: readOnly, onClick: onSpanClick }, index)); }) }));
};

var RichInput = function (props) {
    var id = props.id, value = props.value, type = props.type, autoFocus = props.autoFocus, spellCheck = props.spellCheck, tabIndex = props.tabIndex, maxLength = props.maxLength, enterKeyHint = props.enterKeyHint, onChange = props.onChange, onInput = props.onInput, onKeyDown = props.onKeyDown, onSearch = props.onSearch;
    var rich = value.formats.some(function (f) { return f.type === "inputText"; });
    var keyHint = enterKeyHint || (type === "search" ? "search" : "send");
    var handleChange = react.useCallback(function (ev) {
        if (onChange) {
            onChange({
                text: ev.target.value,
                formats: [],
            });
        }
    }, [onChange]);
    var handleRichChange = react.useCallback(function (val) {
        if (onChange) {
            onChange(val);
        }
    }, [onChange]);
    var handleInput = react.useCallback(function (ev) {
        if (onInput) {
            onInput({
                text: ev.target.value,
                formats: [],
            });
        }
    }, [onInput]);
    var handleRichInput = react.useCallback(function (val) {
        if (onInput) {
            onInput(val);
        }
    }, [onInput]);
    var handleKeyDown = react.useCallback(function (event) {
        if (onKeyDown) {
            onKeyDown(event);
        }
    }, [onKeyDown]);
    var inputRef = react.useRef(null);
    var inputNode = inputRef.current;
    react.useEffect(function () {
        if (inputNode && onSearch) {
            var handler_1 = function (ev) {
                var target = ev.target;
                if (target) {
                    onSearch({
                        text: target.value,
                        formats: [],
                    });
                }
            };
            inputNode.addEventListener("search", handler_1);
            return function () {
                inputNode.removeEventListener("search", handler_1);
            };
        }
        return undefined;
    }, [inputNode, onSearch]);
    return (jsxRuntime.jsx("div", { className: "xappw-rich-input ".concat(props.className), children: rich ? (jsxRuntime.jsx(RichText, { id: id, value: value, onChange: handleRichChange, onInput: handleRichInput, onKeyDown: handleKeyDown, className: "xappw-rich-input__input ".concat(props.className, "__input") })) : (jsxRuntime.jsx("input", { id: id, ref: inputRef, type: type, value: value.text, autoComplete: "off", enterKeyHint: keyHint, autoFocus: autoFocus, placeholder: props.placeholder, spellCheck: spellCheck, tabIndex: tabIndex ? Number(tabIndex) : 0, maxLength: maxLength, className: "xappw-rich-input__input ".concat(props.className, "__input"), onFocus: props.onFocus, onChange: handleChange, onInput: handleInput, onKeyDown: handleKeyDown })) }));
};

var SuggestionsGroupHeading = function (props) {
    return jsxRuntime.jsx("div", { className: "xappw-suggestions-group-heading", children: props.label });
};

function getScrollContainer(node) {
    var walker = node;
    while (walker && !walker.classList.contains("xapp-search-result__suggestions")) {
        walker = walker.parentElement;
    }
    return walker || undefined;
}
var SuggestionsItem = function (props) {
    var data = props.data, current = props.current, ActionsComponent = props.actions, onClick = props.onClick, onHover = props.onHover, onSpanClick = props.onSpanClick;
    var handleClick = react.useCallback(function () {
        onClick(data);
    }, [data, onClick]);
    var handleHover = react.useCallback(function () {
        if (onHover) {
            onHover(data);
        }
    }, [data, onHover]);
    var handleSpanClick = react.useCallback(function (span) {
        if (onSpanClick) {
            return onSpanClick(data, span);
        }
        return undefined;
    }, [onSpanClick, data]);
    var ref = react.useRef(null);
    react.useEffect(function () {
        var node = ref.current;
        if (current && node) {
            var scrollContainer = getScrollContainer(node);
            if (scrollContainer) {
                var scrollBox = scrollContainer.getBoundingClientRect();
                var nodeBox = node.getBoundingClientRect();
                var maxTop = Math.max(scrollBox.top, nodeBox.top);
                var minBottom = Math.min(scrollBox.bottom, nodeBox.bottom);
                var visibleHeight = minBottom - maxTop;
                var actualHeight = nodeBox.height;
                if (visibleHeight < actualHeight * 0.99) {
                    node.scrollIntoView({ behavior: "smooth" });
                }
            }
        }
    }, [current]);
    return (jsxRuntime.jsxs("div", { ref: ref, className: "xappw-suggestions-item ".concat(current ? "xappw-suggestions-item--current" : ""), onClick: handleClick, onMouseEnter: handleHover, children: [jsxRuntime.jsx(RichText, { value: data, className: "xappw-suggestions-item__texts", readOnly: true, onSpanClick: handleSpanClick }), ActionsComponent && (jsxRuntime.jsx("div", { className: "xappw-suggestions-item__actions", children: jsxRuntime.jsx(ActionsComponent, { data: data, current: current }) }))] }));
};

var SuggestionsGroup = function (props) {
    var group = props.group, currentIndex = props.currentIndex, itemActions = props.itemActions;
    var heading = group.heading, items = group.items;
    return (jsxRuntime.jsxs("div", { className: "xappw-suggestions-group", children: [jsxRuntime.jsx("div", { className: "xappw-suggestions-group__heading", children: jsxRuntime.jsx(SuggestionsGroupHeading, { label: heading }) }), jsxRuntime.jsx("div", { className: "xappw-suggestions-group__items", children: items.map(function (item, itemIndex) { return (jsxRuntime.jsx(SuggestionsItem, { data: item, current: currentIndex === itemIndex, actions: itemActions, onClick: props.onItemClick, onHover: props.onItemHover, onSpanClick: props.onSpanClick }, itemIndex)); }) })] }));
};

function getItemsLength(result) {
    return result.reduce(function (prev, cur) { return prev + cur.items.length; }, 0);
}

var SuggestionsList = function (props) {
    var suggestions = props.suggestions, itemActions = props.itemActions, className = props.className;
    var length = react.useMemo(function () {
        if (suggestions) {
            return getItemsLength(suggestions);
        }
        return 0;
    }, [suggestions]);
    var currentIndex = length >= 0 ? props.index : NaN;
    var indexWalker = 0;
    return (jsxRuntime.jsx("div", { className: "xappw-suggestions-list ".concat(className || ""), children: suggestions === null || suggestions === void 0 ? void 0 : suggestions.map(function (group, index) {
            var res = (jsxRuntime.jsx(SuggestionsGroup, { group: group, currentIndex: currentIndex - indexWalker, itemActions: itemActions, onItemClick: props.onItemClick, onItemHover: props.onItemHover, onSpanClick: props.onSpanClick }, index));
            indexWalker += group.items.length;
            return res;
        }) }));
};

function findItemByIndex(groups, index) {
    if (index >= 0) {
        for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
            var group = groups_1[_i];
            for (var _a = 0, _b = group.items; _a < _b.length; _a++) {
                var item = _b[_a];
                if (index <= 0) {
                    return item;
                }
                index--;
            }
        }
    }
    return undefined;
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var order = ["FAQ", "INTENT", "HISTORICAL"];
var ordersMap = order.reduce(function (prev, cur, index) {
    prev[cur] = index;
    return prev;
}, {});
function compareSuggestionItems(left, right, direction) {
    return direction * (ordersMap[right.type] - ordersMap[left.type]);
}
function sortSuggestionItems(items, direction) {
    return __spreadArray([], items, true).sort(function (left, right) { return compareSuggestionItems(left, right, direction); });
}

function parseSuggestionsFormat(format) {
    var types = Object.keys(format);
    var type = types[0];
    var item = format[type];
    if (!item) {
        throw new Error();
    }
    return {
        type: type,
        start: item.start,
        end: item.end,
    };
}
function parseSuggestionsFormats(formats) {
    return formats.map(parseSuggestionsFormat);
}
function parseSuggestionsResponseItem(item) {
    return {
        text: item.suggestion,
        content: item.answer,
        formats: parseSuggestionsFormats(item.format),
        type: item.type,
    };
}
function getHeading(type) {
    switch (type) {
        case "FAQ":
            return "FAQs";
        case "INTENT":
            return "Suggestions";
        case "HISTORICAL":
            return "Suggestions";
        default:
            return type;
    }
}
function parseSuggestionsResponse(response, direction) {
    if (direction === void 0) { direction = 1; }
    if (!response) {
        return undefined;
    }
    var items = sortSuggestionItems(response.suggestions, direction);
    return items.reduce(function (result, current) {
        var mappedItem = parseSuggestionsResponseItem(current);
        if (result.length) {
            var prevGroup = result[result.length - 1];
            if (prevGroup.heading === getHeading(current.type)) {
                prevGroup.items.push(mappedItem);
                return result;
            }
        }
        result.push({
            heading: getHeading(current.type),
            items: [mappedItem],
        });
        return result;
    }, []);
}

/**
 * Append the provided query params to the URL
 *
 * It will overwrite existing params on the URL if there are conflicts
 * @param url
 * @param params
 */
function addQueryParametersToURL(url, params) {
    var existingParams = new URL(url).searchParams;
    params.forEach(function (value, key) {
        existingParams.append(key, value);
    });
    var newUrl = new URL(url);
    newUrl.search = existingParams.toString();
    return newUrl;
}

var defaultOptions = {};
function noop() {
}
function useJsonFetch(url, options) {
    if (options === void 0) { options = defaultOptions; }
    var _a = react.useState({
        state: "paused"
    }), value = _a[0], setValue = _a[1];
    var pause = options.pause;
    react.useEffect(function () {
        if (pause) {
            setValue({
                state: "paused"
            });
            return noop;
        }
        var controller = new AbortController();
        var signal = controller.signal;
        var mounted = true;
        (function () {
            return __awaiter(this, void 0, void 0, function () {
                var response, json, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 4, , 5]);
                            setValue({
                                state: "fetching"
                            });
                            return [4 /*yield*/, fetch(url, { signal: signal })];
                        case 1:
                            response = _a.sent();
                            if (!mounted) return [3 /*break*/, 3];
                            return [4 /*yield*/, response.json()];
                        case 2:
                            json = _a.sent();
                            if (response.ok) {
                                setValue({
                                    state: "success",
                                    data: json
                                });
                            }
                            else {
                                setValue({
                                    state: "error",
                                    error: json
                                });
                            }
                            _a.label = 3;
                        case 3: return [3 /*break*/, 5];
                        case 4:
                            e_1 = _a.sent();
                            if (e_1.name === "AbortError") {
                                setValue({
                                    state: "paused"
                                });
                                return [2 /*return*/];
                            }
                            throw e_1;
                        case 5: return [2 /*return*/];
                    }
                });
            });
        })();
        return function () {
            mounted = false;
            controller.abort();
        };
    }, [url, pause]);
    return value;
}

function useSuggestionsFetch(options) {
    var baseUrl = options.url, context = options.context, query = options.query;
    var url = react.useMemo(function () {
        if (!baseUrl) {
            return undefined;
        }
        var params = new URLSearchParams();
        params.append("size", "5");
        params.append("queryText", query);
        if (context === null || context === void 0 ? void 0 : context.length) {
            params.append("activeContexts", context.join(","));
        }
        return addQueryParametersToURL(baseUrl, params);
    }, [query, context, baseUrl]);
    var response = useJsonFetch(url ? "".concat(url.toString()) : "", {
        pause: !query || !baseUrl
    });
    return response;
}

/**
 * Marketing attribution capture, shared by every widget surface.
 *
 * The chat widget historically sent only `currentUrl`, which meant attribution
 * survived only when the visitor opened the chat on the very page the ad landed
 * them on. Anyone who browsed first arrived unattributed. These helpers capture
 * the parameters on first sight and persist them, so a conversation started three
 * pages later still carries the click that paid for it.
 *
 * Only the parameters below are ever read or stored. The query string as a whole
 * is not, because it routinely carries session tokens and PII.
 */
/** Standard UTM parameters. */
var UTM_PARAMETERS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content"
];
/**
 * Platform click ids.
 *
 * `gbraid` and `wbraid` are what Google substitutes for `gclid` when the click
 * cannot be tied to a cookie — iOS and consent-mode traffic. For home services,
 * where most paid traffic is mobile, omitting them loses attribution on the
 * majority of the spend.
 */
var CLICK_ID_PARAMETERS = [
    "gclid",
    "gbraid",
    "wbraid",
    "msclkid",
    "fbclid"
];
var ATTRIBUTION_PARAMETERS = __spreadArray(__spreadArray([], UTM_PARAMETERS, true), CLICK_ID_PARAMETERS, true);
/**
 * Params AI surfaces put on the links they send people to: Google AI Overviews
 * (`st_source=ai_overview`), Google's `srsltid` click id, and the generic `ref` / `source`
 * that ChatGPT, Perplexity and others use. Read only by the widget `load` event, never stored and
 * never sent with chat messages.
 */
var AI_REFERRAL_PARAMETERS = ["st_source", "srsltid", "ref", "source"];
var STORAGE_KEY_PREFIX = "xa_tracking_";
/** Matches the 30 day window the form widget already uses. */
var DEFAULT_PERSISTENCE_DAYS = 30;
var MAX_VALUE_LENGTH$1 = 255;
/**
 * Values land in a request body and, downstream, in a CRM. Cap the length and
 * reject anything carrying markup or control characters.
 */
function isValidValue$1(value) {
    // eslint-disable-next-line no-control-regex
    return value.length <= MAX_VALUE_LENGTH$1 && !/[<>"'\x00-\x1f]/.test(value);
}
/**
 * Reads the attribution parameters present on a URL. Never throws — a URL we
 * cannot parse simply contributes nothing.
 */
function extractAttributionFromUrl(url) {
    var parsed;
    try {
        parsed = new URL(url);
    }
    catch (_a) {
        return {};
    }
    var attribution = {};
    ATTRIBUTION_PARAMETERS.forEach(function (parameter) {
        var value = parsed.searchParams.get(parameter);
        if (value && isValidValue$1(value)) {
            attribution[parameter] = value;
        }
    });
    return attribution;
}
/**
 * Persists attribution for later conversations. Existing values are overwritten,
 * so the most recent click wins, matching how the ad platforms attribute.
 */
function storeAttribution(attribution, persistenceDays) {
    if (persistenceDays === void 0) { persistenceDays = DEFAULT_PERSISTENCE_DAYS; }
    var expires = Date.now() + persistenceDays * 24 * 60 * 60 * 1000;
    Object.entries(attribution).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (!value) {
            return;
        }
        try {
            localStorage.setItem("".concat(STORAGE_KEY_PREFIX).concat(key), JSON.stringify({ value: value, expires: expires }));
        }
        catch (_b) {
            // Storage can be full or blocked by the browser. Attribution is best
            // effort — never let it break the conversation.
        }
    });
}
/** Reads back unexpired stored attribution, cleaning up anything unreadable. */
function getStoredAttribution() {
    var attribution = {};
    ATTRIBUTION_PARAMETERS.forEach(function (parameter) {
        var key = "".concat(STORAGE_KEY_PREFIX).concat(parameter);
        var stored;
        try {
            stored = localStorage.getItem(key);
        }
        catch (_a) {
            return;
        }
        if (!stored) {
            return;
        }
        try {
            var parsed = JSON.parse(stored);
            if (parsed && parsed.expires > Date.now() && typeof parsed.value === "string") {
                attribution[parameter] = parsed.value;
            }
            else {
                localStorage.removeItem(key);
            }
        }
        catch (_b) {
            localStorage.removeItem(key);
        }
    });
    return attribution;
}
/**
 * The attribution to send with a request: whatever is stored, with anything on
 * the current URL layered on top, and the current URL's values persisted for
 * subsequent pages.
 */
function getAttribution(url) {
    if (url === void 0) { url = window.location.href; }
    var fromUrl = extractAttributionFromUrl(url);
    if (Object.keys(fromUrl).length > 0) {
        storeAttribution(fromUrl);
    }
    return __assign(__assign({}, getStoredAttribution()), fromUrl);
}
/**
 * Strips the query string from a URL, leaving origin + pathname.
 *
 * Referrers and page URLs routinely carry session tokens, email addresses and other
 * PII in their query strings, and a referrer captured at session start is sent with
 * every subsequent message — so the raw value must never be stored. Attribution is
 * read separately, by allowlist, before this is applied.
 *
 * Returns undefined for an empty or unparseable URL rather than passing it through.
 */
function stripQueryString(url) {
    if (!url) {
        return undefined;
    }
    try {
        var parsed = new URL(url);
        return parsed.origin + parsed.pathname;
    }
    catch (_a) {
        return undefined;
    }
}

/**
 * Client-side detection of AI browsing agents (Meta Muse, OpenClaw, ChatGPT agent, Gemini,
 * Claude, Perplexity, ...) visiting a customer's site.
 *
 * Pure: it reads only what it is handed, so it can be tested without a browser. The verdict
 * is a hint, not an identity - it decides whether to show agents a pointer to the MCP server
 * and is reported with the widget `load` event so the server side can do the real classification.
 */
/** User-agent tokens of agents that browse on a person's behalf. Matched case-insensitively. */
var AGENT_UA_TOKENS = [
    "ChatGPT-User",
    "Claude-User",
    "Perplexity-User",
    "GoogleAgent",
    "Google-Agent",
    "MistralAI-User",
    "meta-externalagent",
    "HeadlessChrome",
];
/** User-agent tokens of search-indexing crawlers, classic and AI search alike. */
var SEARCH_CRAWLER_UA_TOKENS = [
    "Googlebot",
    "Google-InspectionTool",
    "Storebot-Google",
    "AdsBot-Google",
    "Mediapartners-Google",
    "bingbot",
    "BingPreview",
    "Applebot",
    "DuckDuckBot",
    "YandexBot",
    "Baiduspider",
    "OAI-SearchBot",
    "PerplexityBot",
];
/**
 * Brands a real, branded Chromium browser adds next to "Chromium". An agent's headless or
 * stock Chromium carries "Chromium" alone - the observed Meta Muse fingerprint.
 */
var BRANDED_CHROMIUM = ["Google Chrome", "Microsoft Edge", "Opera", "Brave"];
function includesToken(userAgent, token) {
    return userAgent.toLowerCase().indexOf(token.toLowerCase()) >= 0;
}
function isLinuxDesktop(nav, userAgent) {
    var data = nav.userAgentData;
    if (data === null || data === void 0 ? void 0 : data.mobile) {
        return false;
    }
    if (data === null || data === void 0 ? void 0 : data.platform) {
        return data.platform === "Linux";
    }
    return /\bLinux\b/.test(userAgent) && !/\bAndroid\b/.test(userAgent);
}
function isChromiumOnly(nav) {
    var _a;
    var names = (((_a = nav.userAgentData) === null || _a === void 0 ? void 0 : _a.brands) || []).map(function (b) { return b.brand; });
    return (names.indexOf("Chromium") >= 0 && !names.some(function (name) { return BRANDED_CHROMIUM.indexOf(name) >= 0; }));
}
function detectBrowsingAgent(nav) {
    var userAgent = (nav === null || nav === void 0 ? void 0 : nav.userAgent) || "";
    var signals = [];
    if (!nav) {
        return { isAgent: false, isSearchCrawler: false, signals: signals };
    }
    if (nav.webdriver === true) {
        signals.push("webdriver");
    }
    AGENT_UA_TOKENS.forEach(function (token) {
        if (includesToken(userAgent, token)) {
            signals.push("ua:".concat(token));
        }
    });
    if (isChromiumOnly(nav) && isLinuxDesktop(nav, userAgent)) {
        signals.push("chromium-only-linux");
    }
    var isSearchCrawler = SEARCH_CRAWLER_UA_TOKENS.some(function (token) {
        return includesToken(userAgent, token);
    });
    return { isAgent: !isSearchCrawler && signals.length > 0, isSearchCrawler: isSearchCrawler, signals: signals };
}

/**
 * Pointing AI browsing agents at the tenant's public MCP server.
 *
 * agent-server serves a public, unauthenticated, per-tenant homeowner MCP server at
 * `https://agentic.xapp.ai/{appId}/mcp` with a manifest at
 * `/{appId}/.well-known/mcp/manifest.json` and a server card at `/{appId}/mcp/server-card`. An agent that finds it can ask the business
 * questions and request a callback directly instead of scraping and form-filling.
 */
var DEFAULT_AGENT_MCP_HOST = "https://agentic.xapp.ai";
var APP_ID = /^[A-Za-z0-9_-]{1,128}$/;
var HOMEOWNER_PATHS = ["/chat/stream", "/chat/close"];
function endpointsFor(origin, appId) {
    if (!APP_ID.test(appId)) {
        return undefined;
    }
    var base = "".concat(origin.replace(/\/+$/, ""), "/").concat(appId);
    return {
        appId: appId,
        mcpUrl: "".concat(base, "/mcp"),
        manifestUrl: "".concat(base, "/.well-known/mcp/manifest.json"),
        serverCardUrl: "".concat(base, "/mcp/server-card"),
    };
}
function httpUrl(value) {
    try {
        var url = new URL(value);
        return url.protocol === "https:" || url.protocol === "http:" ? url : undefined;
    }
    catch (_a) {
        return undefined;
    }
}
/** The first path segment of an http(s) URL, after removing a known endpoint suffix. */
function firstSegment(url, suffixes) {
    var path = url.pathname.replace(/\/+$/, "");
    suffixes.forEach(function (suffix) {
        if (path.endsWith(suffix)) {
            path = path.slice(0, -suffix.length);
        }
    });
    var segments = path.split("/").filter(Boolean);
    return segments.length === 1 ? segments[0] : undefined;
}
/**
 * Resolves the tenant's public MCP endpoints. Order: explicit `agentMcpUrl`, then explicit
 * `appId` on the agent host, then the appId inside a homeowner MCP connection's serverUrl.
 * Undefined when none identifies the tenant.
 */
function resolveAgentMcpEndpoints(source) {
    var _a;
    if (!source) {
        return undefined;
    }
    if (source.agentMcpUrl) {
        var url = httpUrl(source.agentMcpUrl);
        var appId = url && firstSegment(url, ["/mcp"]);
        return url && appId ? endpointsFor(url.origin, appId) : undefined;
    }
    if (source.appId) {
        var host = source.agentMcpHost && httpUrl(source.agentMcpHost);
        return endpointsFor(host ? host.origin : DEFAULT_AGENT_MCP_HOST, source.appId);
    }
    var connection = source.connection;
    if ((connection === null || connection === void 0 ? void 0 : connection.type) === "mcp" &&
        connection.serverUrl &&
        (((_a = connection.mcp) === null || _a === void 0 ? void 0 : _a.mode) || "homeowner") === "homeowner") {
        var url = httpUrl(connection.serverUrl);
        var appId = url && firstSegment(url, HOMEOWNER_PATHS);
        return url && appId ? endpointsFor(url.origin, appId) : undefined;
    }
    return undefined;
}
var OWN_TAG = "data-xapp-mcp";
function upsert(doc, tag, selector, attributes) {
    var existing = doc.head.querySelector(selector);
    if (existing && !existing.hasAttribute(OWN_TAG)) {
        // The site owner advertises their own - theirs wins.
        return;
    }
    var element = existing || doc.createElement(tag);
    element.setAttribute(OWN_TAG, "");
    Object.keys(attributes).forEach(function (name) { return element.setAttribute(name, attributes[name]); });
    if (!existing) {
        doc.head.appendChild(element);
    }
}
/** Adds (or refreshes) the MCP discovery tags in <head>. Idempotent. */
function injectMcpDiscoveryTags(endpoints, doc) {
    if (doc === void 0) { doc = document; }
    if (!(doc === null || doc === void 0 ? void 0 : doc.head)) {
        return;
    }
    upsert(doc, "link", 'link[rel="mcp-server"]', { rel: "mcp-server", href: endpoints.mcpUrl });
    upsert(doc, "link", 'link[rel="mcp-manifest"]', {
        rel: "mcp-manifest",
        href: endpoints.manifestUrl,
    });
    upsert(doc, "link", 'link[rel="mcp-server-card"]', {
        rel: "mcp-server-card",
        href: endpoints.serverCardUrl,
    });
    upsert(doc, "meta", 'meta[name="mcp-server"]', {
        name: "mcp-server",
        content: endpoints.mcpUrl,
    });
}
/**
 * The note shown to AI assistants. Deliberately informational rather than imperative:
 * agents treat instruction-shaped page text as prompt injection and discard it.
 */
function buildAgentNoticeText(mcpUrl, businessName) {
    var name = (businessName === null || businessName === void 0 ? void 0 : businessName.trim()) || "this business";
    return ("AI assistant? You can talk to ".concat(name, " directly over MCP: ").concat(mcpUrl, " ") +
        "\u2014 ask questions, check services, and request a callback or quote for your user.");
}
var AGENT_NOTICE_ID = "xapp-agent-notice";
var AGENT_NOTICE_HIDDEN_ID = "xapp-agent-notice-sr";
/** Text with the MCP URL as a link, built with DOM APIs so no value is parsed as markup. */
function fillNotice(doc, container, options) {
    var text = buildAgentNoticeText(options.mcpUrl, options.businessName);
    var at = text.indexOf(options.mcpUrl);
    var link = doc.createElement("a");
    link.href = options.mcpUrl;
    link.rel = "nofollow";
    link.textContent = options.mcpUrl;
    link.style.color = "inherit";
    container.appendChild(doc.createTextNode(text.slice(0, at)));
    container.appendChild(link);
    container.appendChild(doc.createTextNode(text.slice(at + options.mcpUrl.length)));
}
/**
 * Renders the agent notice: a small, dismissible note a person can ignore, plus a
 * visually-hidden copy for agents that read the DOM or accessibility tree rather than pixels.
 * Only call this for a detected agent. Renders once.
 */
function renderAgentNotice(options, doc) {
    if (doc === void 0) { doc = document; }
    if (!(doc === null || doc === void 0 ? void 0 : doc.body)) {
        return;
    }
    if (!doc.getElementById(AGENT_NOTICE_HIDDEN_ID)) {
        var hidden = doc.createElement("div");
        hidden.id = AGENT_NOTICE_HIDDEN_ID;
        hidden.style.cssText =
            "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;" +
                "clip:rect(0,0,0,0);white-space:nowrap;border:0;";
        fillNotice(doc, hidden, options);
        doc.body.appendChild(hidden);
    }
    if (doc.getElementById(AGENT_NOTICE_ID)) {
        return;
    }
    var notice = doc.createElement("div");
    notice.id = AGENT_NOTICE_ID;
    notice.setAttribute("role", "note");
    notice.style.cssText =
        "position:fixed;left:8px;bottom:8px;max-width:320px;z-index:2147483000;" +
            "padding:6px 24px 6px 8px;border-radius:4px;background:rgba(255,255,255,0.92);" +
            "color:#555;font:11px/1.4 -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;" +
            "box-shadow:0 1px 3px rgba(0,0,0,0.15);word-break:break-word;";
    fillNotice(doc, notice, options);
    var close = doc.createElement("button");
    close.type = "button";
    close.setAttribute("aria-label", "Dismiss");
    close.textContent = "×";
    close.style.cssText =
        "position:absolute;top:2px;right:4px;border:0;background:none;color:#888;" +
            "font-size:14px;line-height:1;cursor:pointer;padding:2px;";
    close.addEventListener("click", function () { return notice.remove(); });
    notice.appendChild(close);
    doc.body.appendChild(notice);
}

function isModelContext(value) {
    return !!value && typeof value.registerTool === "function";
}
/** The page's model context, if this browser has WebMCP. */
function findModelContext(doc, nav) {
    if (doc === void 0) { doc = typeof document !== "undefined"
        ? document
        : undefined; }
    if (nav === void 0) { nav = typeof navigator !== "undefined"
        ? navigator
        : undefined; }
    if (isModelContext(doc === null || doc === void 0 ? void 0 : doc.modelContext)) {
        return doc.modelContext;
    }
    if (isModelContext(nav === null || nav === void 0 ? void 0 : nav.modelContext)) {
        return nav.modelContext;
    }
    return undefined;
}
/**
 * A minimal client for the tenant's homeowner MCP endpoint: one `tools/call` per request, no
 * session. The endpoint is public and the server keeps no state we need, so the MCP
 * initialize handshake would only add a round trip (and a session the next App Runner
 * instance has never heard of).
 */
var HomeownerMcpClient = /** @class */ (function () {
    function HomeownerMcpClient(mcpUrl, fetchImpl) {
        this.mcpUrl = mcpUrl;
        this.nextId = 1;
        this.fetchImpl = fetchImpl || (typeof fetch === "function" ? fetch : undefined);
    }
    HomeownerMcpClient.prototype.callTool = function (name, args) {
        return __awaiter(this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof this.fetchImpl !== "function") {
                            throw new Error("fetch is not available");
                        }
                        return [4 /*yield*/, this.fetchImpl(this.mcpUrl, {
                                method: "POST",
                                headers: { "Content-Type": "application/json", Accept: "application/json" },
                                body: JSON.stringify({
                                    jsonrpc: "2.0",
                                    id: this.nextId++,
                                    method: "tools/call",
                                    params: { name: name, arguments: args },
                                }),
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error("MCP endpoint answered ".concat(response.status));
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = (_a.sent());
                        if (body.error) {
                            throw new Error(body.error.message || "MCP error ".concat(body.error.code));
                        }
                        return [2 /*return*/, toolResultToValue(body.result)];
                }
            });
        });
    };
    return HomeownerMcpClient;
}());
/**
 * MCP tool results are text parts; agents want a value. JSON text becomes the object it
 * encodes, prose stays `{ text }`, and a tool-level error becomes `{ ok: false, message }` so
 * the agent can read the validation message and try again rather than seeing a thrown call.
 */
function toolResultToValue(result) {
    var text = ((result === null || result === void 0 ? void 0 : result.content) || [])
        .filter(function (part) { return part.type === "text" && typeof part.text === "string"; })
        .map(function (part) { return part.text; })
        .join("\n");
    if (result === null || result === void 0 ? void 0 : result.isError) {
        return { ok: false, message: text };
    }
    try {
        return JSON.parse(text);
    }
    catch (_a) {
        return { text: text };
    }
}
var CALLBACK_FIELDS = [
    "name",
    "phone",
    "email",
    "address",
    "zip",
    "serviceType",
    "message",
    "preferredContactTime",
    "urgency",
];
function pick(input, keys) {
    var out = {};
    keys.forEach(function (key) {
        if (input && input[key] !== undefined && input[key] !== null && input[key] !== "") {
            out[key] = input[key];
        }
    });
    return out;
}
/**
 * The tools a visitor's agent gets. Names and descriptions are written for that agent, which
 * is helping a person on the business's site; the server's own tool descriptions address the
 * business owner and would mislead it.
 */
function buildSiteTools(endpoints, caller, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var business = ((_a = options.businessName) === null || _a === void 0 ? void 0 : _a.trim()) || "this business";
    var readOnly = {
        readOnlyHint: true,
        destructiveHint: false,
        openWorldHint: false,
    };
    return [
        {
            name: "get_business_info",
            description: "What ".concat(business, " offers: services, service area, hours, and how to reach them. ") +
                "Call this first when the user asks what the business does or whether it can help.",
            inputSchema: {
                type: "object",
                properties: {},
                required: [],
                additionalProperties: false,
            },
            annotations: readOnly,
            execute: function () { return caller.callTool("get_business_context", {}); },
        },
        {
            name: "search_business_knowledge",
            description: "Search ".concat(business, "'s FAQs and website content to answer a question: services, ") +
                "pricing, policies, scheduling, warranties, service area.",
            inputSchema: {
                type: "object",
                properties: {
                    query: { type: "string", description: "The user's question, in their words." },
                },
                required: ["query"],
                additionalProperties: false,
            },
            annotations: readOnly,
            execute: function (input) { return caller.callTool("search_knowledge_base", pick(input, ["query"])); },
        },
        {
            name: "request_callback",
            description: "Ask ".concat(business, " to contact the user about work they need. Sends the user's name, ") +
                "phone or email, address and request to the business as a lead. Only call this after " +
                "the user has agreed to be contacted. Returns validation errors to fix, or confirmation.",
            inputSchema: {
                type: "object",
                properties: {
                    name: { type: "string", description: "The user's full name." },
                    phone: {
                        type: "string",
                        description: "Phone number, at least 10 digits. Required if no email.",
                    },
                    email: { type: "string", description: "Email address. Required if no phone." },
                    address: {
                        type: "string",
                        description: "Street address where the work is needed.",
                    },
                    zip: {
                        type: "string",
                        description: "ZIP or postal code where the work is needed.",
                    },
                    serviceType: {
                        type: "string",
                        description: "The kind of work or service needed.",
                    },
                    message: {
                        type: "string",
                        description: "What the user needs, in their words.",
                    },
                    preferredContactTime: {
                        type: "string",
                        description: "When the user would like to be contacted.",
                    },
                    urgency: {
                        type: "string",
                        description: 'How urgent: "urgent", "this week" or "flexible".',
                    },
                },
                required: ["name"],
                additionalProperties: false,
            },
            annotations: { readOnlyHint: false, destructiveHint: false, openWorldHint: false },
            execute: function (input) {
                return caller.callTool("collect_contact_info", __assign(__assign({ appId: endpoints.appId, source: "webmcp", channel: "mcp" }, (options.channelId ? { channelId: options.channelId } : {})), pick(input, CALLBACK_FIELDS)));
            },
        },
    ];
}
var registered = new WeakSet();
/**
 * Registers the site tools on the page's model context. Resolves with how many were
 * registered: 0 in a browser without WebMCP, on a second call for the same context, or when
 * registration fails. Never rejects: this runs at widget start and must not take it down.
 */
function registerSiteTools(options) {
    return __awaiter(this, void 0, void 0, function () {
        var context, client, tools, count, _i, tools_1, tool;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, , 6]);
                    context = findModelContext(options.doc, options.nav);
                    if (!context || registered.has(context)) {
                        return [2 /*return*/, 0];
                    }
                    registered.add(context);
                    client = new HomeownerMcpClient(options.endpoints.mcpUrl, options.fetchImpl);
                    tools = buildSiteTools(options.endpoints, client, options);
                    count = 0;
                    _i = 0, tools_1 = tools;
                    _b.label = 1;
                case 1:
                    if (!(_i < tools_1.length)) return [3 /*break*/, 4];
                    tool = tools_1[_i];
                    return [4 /*yield*/, context.registerTool(tool)];
                case 2:
                    _b.sent();
                    count++;
                    _b.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, count];
                case 5:
                    _b.sent();
                    return [2 /*return*/, 0];
                case 6: return [2 /*return*/];
            }
        });
    });
}

var NO_VERDICT = { isAgent: false, isSearchCrawler: false, signals: [] };
/**
 * What a widget does on load for AI browsing agents: detect one, advertise the tenant's MCP
 * server in <head>, and - when the tenant opted in - show a detected agent a short note
 * pointing at it, and register the server's tools as WebMCP site tools for the agent in the
 * visitor's own browser. Never throws.
 */
function startAgentDiscovery(options, nav, doc) {
    if (nav === void 0) { nav = typeof navigator !== "undefined"
        ? navigator
        : undefined; }
    if (doc === void 0) { doc = typeof document !== "undefined" ? document : undefined; }
    var verdict = NO_VERDICT;
    var endpoints;
    var siteTools;
    try {
        verdict = detectBrowsingAgent(nav);
    }
    catch (_a) {
        // A navigator that throws tells us nothing; carry on as a person.
    }
    try {
        endpoints = resolveAgentMcpEndpoints(options.mcp);
        if (endpoints) {
            injectMcpDiscoveryTags(endpoints);
            if (verdict.isAgent && options.notice === true) {
                renderAgentNotice({
                    mcpUrl: endpoints.mcpUrl,
                    businessName: options.businessName,
                });
            }
            if (options.siteTools === true) {
                siteTools = registerSiteTools({
                    endpoints: endpoints,
                    doc: doc,
                    nav: nav,
                    businessName: options.businessName,
                    channelId: options.channelId,
                });
            }
        }
    }
    catch (_b) {
        // Discovery is best effort.
    }
    return { verdict: verdict, endpoints: endpoints, siteTools: siteTools };
}

/** Page params whose VALUES the load event may send, each as its own metadata field. */
var LOAD_EVENT_PAGE_PARAMETERS = __spreadArray(__spreadArray([], ATTRIBUTION_PARAMETERS, true), AI_REFERRAL_PARAMETERS, true);
var DEFAULT_WIDGET_EVENTS_ORIGIN = "https://api.xapp.ai";
var EVENTS_PATH = "/cms/widget/events";
var MAX_REFERRER_LENGTH = 500;
var MAX_VALUE_LENGTH = 255;
var MAX_OTHER_KEYS = 20;
var MAX_OTHER_KEYS_LENGTH = 300;
var PLAIN_KEY = /^[A-Za-z0-9_.[\]-]{1,64}$/;
/**
 * The page global XAPP's own web scraper sets before any page script runs, so the crawler's
 * widget events are reported as `internal` traffic instead of as an AI agent. The crawler cannot
 * mark these events with a request header the way it marks the widget script load: a custom
 * header on the widget's cross-origin fetch would trigger a CORS preflight.
 */
var INTERNAL_TRAFFIC_GLOBAL = "__xappInternal";
var INTERNAL_TRAFFIC_VALUE = /^[a-z][a-z-]{0,31}$/;
/** The page's internal traffic mark (e.g. `crawler`), or undefined. Never throws. */
function readInternalTrafficMark() {
    try {
        var value = window[INTERNAL_TRAFFIC_GLOBAL];
        return typeof value === "string" && INTERNAL_TRAFFIC_VALUE.test(value) ? value : undefined;
    }
    catch (_a) {
        return undefined;
    }
}
function isValidValue(value) {
    // eslint-disable-next-line no-control-regex
    return value.length <= MAX_VALUE_LENGTH && !/[<>"'\x00-\x1f]/.test(value);
}
function pageFields(pageUrl) {
    var url;
    try {
        url = new URL(pageUrl);
    }
    catch (_a) {
        return {};
    }
    var fields = { currentUrl: url.origin + url.pathname };
    var otherKeys = [];
    var otherLength = 0;
    url.searchParams.forEach(function (value, name) {
        if (LOAD_EVENT_PAGE_PARAMETERS.indexOf(name) >= 0) {
            if (fields[name] === undefined && value && isValidValue(value)) {
                fields[name] = value;
            }
            return;
        }
        if (!PLAIN_KEY.test(name) || otherKeys.indexOf(name) >= 0) {
            return;
        }
        var added = (otherKeys.length ? 1 : 0) + name.length;
        if (otherKeys.length >= MAX_OTHER_KEYS || otherLength + added > MAX_OTHER_KEYS_LENGTH) {
            return;
        }
        otherKeys.push(name);
        otherLength += added;
    });
    if (otherKeys.length) {
        fields.pageQueryKeys = otherKeys.join(",");
    }
    return fields;
}
/**
 * The load event's page, browser and agent metadata. Callers add their own identity fields
 * (sessionId, userId, formId). Never throws.
 */
function buildLoadEventMetadata(input) {
    var _a;
    var metadata = pageFields(input.pageUrl);
    var nav = input.nav;
    try {
        if (nav === null || nav === void 0 ? void 0 : nav.userAgent)
            metadata.userAgent = nav.userAgent;
        metadata.webdriver = (nav === null || nav === void 0 ? void 0 : nav.webdriver) === true ? "1" : "0";
        var brands = (_a = nav === null || nav === void 0 ? void 0 : nav.userAgentData) === null || _a === void 0 ? void 0 : _a.brands;
        if (brands && brands.length) {
            metadata.uaBrands = brands
                .map(function (b) { return "".concat(b.brand, "/").concat(String(b.version).split(".")[0]); })
                .join("|");
        }
        if (nav === null || nav === void 0 ? void 0 : nav.language)
            metadata.language = nav.language;
    }
    catch (_b) {
        // A navigator that throws contributes nothing further.
    }
    var referrer = stripQueryString(input.referrer);
    if (referrer)
        metadata.referrer = referrer.slice(0, MAX_REFERRER_LENGTH);
    metadata.agentVerdict = input.verdict.isAgent ? "1" : "0";
    if (input.verdict.signals.length) {
        metadata.agentSignals = input.verdict.signals.join(",");
    }
    var internal = readInternalTrafficMark();
    if (internal)
        metadata.internal = internal;
    try {
        metadata.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    catch (_c) {
        // Intl unavailable - skip timezone
    }
    if (input.screen) {
        metadata.screenWidth = String(input.screen.width);
        metadata.screenHeight = String(input.screen.height);
    }
    if (input.viewport) {
        metadata.viewportWidth = String(input.viewport.width);
        metadata.viewportHeight = String(input.viewport.height);
    }
    return metadata;
}
/**
 * Where the widget events endpoint lives. A stentor-api run URL
 * (`https://api.xapp.ai/apps/{appId}/run`) names it by its origin - the same derivation the
 * form widget's StentorApi uses. Anything else (a chat router websocket, the agent server)
 * is not stentor-api, so the production API is used.
 */
function resolveWidgetEventsUrl(serverUrl) {
    if (serverUrl) {
        try {
            var url = new URL(serverUrl);
            if ((url.protocol === "https:" || url.protocol === "http:") &&
                /\/apps\//.test(url.pathname)) {
                return "".concat(url.origin).concat(EVENTS_PATH);
            }
        }
        catch (_a) {
            // fall through
        }
    }
    return "".concat(DEFAULT_WIDGET_EVENTS_ORIGIN).concat(EVENTS_PATH);
}
/**
 * Claims this page load's `load` event for a widget type. True the first time per page load,
 * across every copy of the bundle on the page; false after that.
 */
function claimPageLoadEvent(widgetType) {
    try {
        var w = window;
        var claimed = (w.__xappLoadEvents = w.__xappLoadEvents || {});
        if (claimed[widgetType]) {
            return false;
        }
        claimed[widgetType] = true;
        return true;
    }
    catch (_a) {
        return false;
    }
}
/**
 * POSTs the `load` event, fire-and-forget with keepalive. Never throws.
 *
 * @returns true when the request was queued.
 */
function sendWidgetLoadEvent(input) {
    if (!input.key || typeof fetch !== "function") {
        return false;
    }
    try {
        var body = {
            key: input.key,
            widgetType: input.widgetType,
            events: [
                {
                    eventType: "load",
                    metadata: __assign({ timestamp: new Date().toISOString() }, input.metadata),
                    data: {},
                },
            ],
        };
        fetch(input.eventsUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
            keepalive: true,
        }).catch(function () { return undefined; });
        return true;
    }
    catch (_a) {
        return false;
    }
}

/**
 * Stop the host page scrolling behind an open overlay.
 *
 * `body { overflow: hidden }` is the obvious way to do this, and is what both widgets used
 * to do — but **iOS Safari ignores `overflow: hidden` on the body**, so the customer's page
 * carried on scrolling under the modal. The technique that does work there is to take the
 * body out of flow at a negative offset equal to the current scroll position, then put it
 * back and re-scroll to that exact position on release.
 *
 * Reference counted rather than a plain on/off flag, and the count lives on the `<body>`
 * element rather than in module scope. That is deliberate: the chat widget's `FormModal`
 * loads the **standalone** form widget bundle, which carries its own copy of this module,
 * so the two overlays that can be open at once are not sharing any JS state. With a module
 * counter, the second lock would read the already-pinned scroll position (which the browser
 * reports as 0), the first release would unpin the body while the second overlay was still
 * open, and the second release would then re-apply `position: fixed` and leave the host page
 * stuck. The DOM is the only thing both bundles can agree on.
 */
/** How many overlays currently hold the lock. Absent means unlocked. */
var COUNT_ATTRIBUTE$1 = "data-xapp-scroll-lock";
/** What to put back when the last one lets go, as JSON. */
var RESTORE_ATTRIBUTE = "data-xapp-scroll-lock-restore";
var PINNED_PROPERTIES = ["position", "top", "left", "right", "width", "overflow"];
function readCount$1(body) {
    var count = Number(body.getAttribute(COUNT_ATTRIBUTE$1));
    return Number.isFinite(count) && count > 0 ? count : 0;
}
function captureRestorePoint(body) {
    var inlineStyles = PINNED_PROPERTIES.reduce(function (styles, property) {
        styles[property] = body.style.getPropertyValue(property);
        return styles;
    }, {});
    return { scrollY: window.scrollY || window.pageYOffset || 0, inlineStyles: inlineStyles };
}
function takeRestorePoint(body) {
    var serialized = body.getAttribute(RESTORE_ATTRIBUTE);
    body.removeAttribute(RESTORE_ATTRIBUTE);
    try {
        var parsed = JSON.parse(serialized || "");
        if (parsed && typeof parsed.scrollY === "number" && parsed.inlineStyles) {
            return parsed;
        }
    }
    catch (_a) {
        // Fall through: something else rewrote the attribute. Better to clear our own
        // properties and leave the page usable than to throw and leave it pinned.
    }
    return { scrollY: 0, inlineStyles: {} };
}
/**
 * Lock the body and return the release function.
 *
 * The returned function is idempotent — calling it twice is a no-op, which matters because
 * React StrictMode runs an effect's cleanup more than once.
 */
function lockBodyScroll() {
    if (typeof document === "undefined" || typeof window === "undefined") {
        return function () { return undefined; };
    }
    var body = document.body;
    if (readCount$1(body) === 0) {
        var restorePoint = captureRestorePoint(body);
        body.setAttribute(RESTORE_ATTRIBUTE, JSON.stringify(restorePoint));
        body.style.position = "fixed";
        body.style.top = "-".concat(restorePoint.scrollY, "px");
        body.style.left = "0";
        body.style.right = "0";
        body.style.width = "100%";
        // Redundant next to `position: fixed`, but harmless, and it keeps the behaviour the
        // widgets already had on the browsers that do honour it.
        body.style.overflow = "hidden";
    }
    body.setAttribute(COUNT_ATTRIBUTE$1, String(readCount$1(body) + 1));
    var released = false;
    return function releaseBodyScroll() {
        if (released) {
            return;
        }
        released = true;
        var remaining = readCount$1(body) - 1;
        if (remaining > 0) {
            body.setAttribute(COUNT_ATTRIBUTE$1, String(remaining));
            return;
        }
        if (remaining < 0) {
            return;
        }
        body.removeAttribute(COUNT_ATTRIBUTE$1);
        var _a = takeRestorePoint(body), scrollY = _a.scrollY, inlineStyles = _a.inlineStyles;
        PINNED_PROPERTIES.forEach(function (property) {
            if (inlineStyles[property]) {
                body.style.setProperty(property, inlineStyles[property]);
            }
            else {
                body.style.removeProperty(property);
            }
        });
        // An empty `style=""` on the host page's body is untidy and is not what we found.
        if (!body.style.length) {
            body.removeAttribute("style");
        }
        window.scrollTo(0, scrollY);
    };
}
/**
 * Lock the body scroll for as long as the calling component is mounted.
 *
 * The cleanup runs on unmount, so a modal that disappears without a clean close — a route
 * change, a parent re-render, an error boundary — still leaves the page scrollable.
 */
function useBodyScrollLock(enabled) {
    if (enabled === void 0) { enabled = true; }
    react.useEffect(function () {
        if (!enabled) {
            return undefined;
        }
        return lockBodyScroll();
    }, [enabled]);
}

/**
 * Publish the visual viewport's geometry as CSS custom properties, so overlays can size
 * themselves around the soft keyboard.
 *
 * We are an **embedded** widget: the customer owns the host page's `<meta name="viewport">`,
 * so we cannot add `interactive-widget=resizes-content` and let the browser solve this for
 * us. Reading `window.visualViewport` ourselves is the only mechanism we control. (Injecting
 * or mutating the host's viewport meta is not an option — it is not ours, and breaking it
 * breaks the whole page in ways nobody would attribute to us.)
 *
 * Three properties are published on `<html>`:
 *
 *   --xapp-viewport-height      the visible height, in px
 *   --xapp-viewport-offset-top  how far the visual viewport has been scrolled down within
 *                               the layout viewport — nonzero on iOS when the keyboard
 *                               pushes the page up
 *   --xapp-keyboard-inset       layout height minus visual height: how much the keyboard
 *                               (or any other browser UI) is covering
 *
 * `--xapp-keyboard-inset` is the one worth having. It is what a `padding-bottom` wants, and
 * deriving it here means the consuming CSS does not have to do arithmetic across two
 * variables that update at slightly different moments.
 *
 * Reference counted on the DOM, for the same reason `bodyScrollLock` is: chat-widget's
 * `FormModal` loads the **standalone** form-widget bundle, which carries its own copy of
 * this module. Two independent copies can be live at once, and a module-scope counter would
 * not see across them. Without counting, closing the form modal while the chat panel is
 * still open (with the keyboard still up) would clear the properties out from under the
 * panel and snap it back to its fallback height mid-interaction.
 */
var HEIGHT_PROPERTY = "--xapp-viewport-height";
var OFFSET_TOP_PROPERTY = "--xapp-viewport-offset-top";
var KEYBOARD_INSET_PROPERTY = "--xapp-keyboard-inset";
/** How many subscribers currently want these properties maintained. */
var COUNT_ATTRIBUTE = "data-xapp-viewport-subscribers";
/**
 * Below this, a shrunken viewport is treated as browser chrome rather than a keyboard.
 * Address bars collapse and expand by ~60-90px during normal scrolling, and reacting to
 * that would make the layout twitch while the user is only reading.
 */
var KEYBOARD_THRESHOLD_PX = 120;
function readCount(root) {
    var count = Number(root.getAttribute(COUNT_ATTRIBUTE));
    return Number.isFinite(count) && count > 0 ? count : 0;
}
/**
 * Write the current geometry to `<html>`.
 *
 * Deliberately does nothing when `visualViewport` is unavailable: the consuming CSS falls
 * back to `100dvh`, which is correct-ish and certainly better than a zero height. Publishing
 * `0px` would collapse the widget entirely — a worse failure than the one being fixed.
 */
function publish(root) {
    var viewport = typeof window === "undefined" ? undefined : window.visualViewport;
    if (!viewport) {
        return;
    }
    var height = viewport.height, offsetTop = viewport.offsetTop;
    if (!(height > 0)) {
        // Mid-transition, or a browser reporting nonsense. Keep the last good values.
        return;
    }
    // window.innerHeight is the LAYOUT viewport, which the keyboard does not shrink on iOS.
    // The difference between the two is the occluded strip.
    var layoutHeight = window.innerHeight || height;
    var rawInset = Math.max(0, layoutHeight - height);
    var inset = rawInset >= KEYBOARD_THRESHOLD_PX ? rawInset : 0;
    root.style.setProperty(HEIGHT_PROPERTY, "".concat(Math.round(height), "px"));
    root.style.setProperty(OFFSET_TOP_PROPERTY, "".concat(Math.round(offsetTop), "px"));
    root.style.setProperty(KEYBOARD_INSET_PROPERTY, "".concat(Math.round(inset), "px"));
}
function clear(root) {
    root.style.removeProperty(HEIGHT_PROPERTY);
    root.style.removeProperty(OFFSET_TOP_PROPERTY);
    root.style.removeProperty(KEYBOARD_INSET_PROPERTY);
}
/**
 * Start publishing viewport geometry. Returns a release function.
 *
 * Imperative twin of {@link useVisualViewportProperties}, for callers outside React.
 */
function trackVisualViewport() {
    if (typeof document === "undefined") {
        return function () { return undefined; };
    }
    var root = document.documentElement;
    root.setAttribute(COUNT_ATTRIBUTE, String(readCount(root) + 1));
    publish(root);
    var viewport = typeof window === "undefined" ? undefined : window.visualViewport;
    var frame;
    var onChange = function () {
        // These fire many times per second through the keyboard animation. Coalescing to one
        // write per frame keeps us off the layout-thrash path.
        if (frame !== undefined) {
            return;
        }
        frame = window.requestAnimationFrame(function () {
            frame = undefined;
            publish(root);
        });
    };
    // `scroll` matters as much as `resize`: on iOS the keyboard scrolls the visual viewport
    // within the layout viewport, and offsetTop only changes on that event.
    viewport === null || viewport === void 0 ? void 0 : viewport.addEventListener("resize", onChange);
    viewport === null || viewport === void 0 ? void 0 : viewport.addEventListener("scroll", onChange);
    var released = false;
    return function () {
        if (released) {
            return;
        }
        released = true;
        viewport === null || viewport === void 0 ? void 0 : viewport.removeEventListener("resize", onChange);
        viewport === null || viewport === void 0 ? void 0 : viewport.removeEventListener("scroll", onChange);
        if (frame !== undefined) {
            window.cancelAnimationFrame(frame);
            frame = undefined;
        }
        var remaining = readCount(root) - 1;
        if (remaining > 0) {
            root.setAttribute(COUNT_ATTRIBUTE, String(remaining));
            return;
        }
        root.removeAttribute(COUNT_ATTRIBUTE);
        clear(root);
    };
}
/**
 * Publish viewport geometry for as long as this component is mounted.
 *
 * @param enabled pass `false` to opt out — e.g. above the mobile breakpoint, where there is
 *                no soft keyboard to work around and the desktop sizing should stand.
 */
function useVisualViewportProperties(enabled) {
    if (enabled === void 0) { enabled = true; }
    react.useEffect(function () {
        if (!enabled) {
            return undefined;
        }
        return trackVisualViewport();
    }, [enabled]);
}
/** Read the published inset, or 0 if nothing has published one. */
function readInset() {
    var value = getComputedStyle(document.documentElement).getPropertyValue(KEYBOARD_INSET_PROPERTY);
    var inset = parseFloat(value);
    return Number.isFinite(inset) ? inset : 0;
}
function scrollIntoViewIfPossible(element) {
    if (element && "scrollIntoView" in element) {
        // block: "nearest" scrolls the minimum needed, so a field already in view does not
        // jump. Anything more aggressive fights the browser's own attempt and overshoots.
        element.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
}
/**
 * Scroll whatever the user has focused back into view when the keyboard covers it.
 *
 * Browsers mostly do this themselves, but not reliably inside a `position: fixed` overlay —
 * which is exactly what both widgets are. The failure looks like tapping the last field on a
 * step and having it disappear behind the keyboard.
 *
 * **The ordering is the whole problem.** On a device the sequence is: focus lands, *then*
 * the keyboard opens, *then* the viewport events fire. So reading the inset inside the
 * `focusin` handler sees `0` and does nothing — on precisely the case this exists for, the
 * first tap into a field near the bottom of a step. It has to react to the inset becoming
 * nonzero and scroll whatever is focused at that moment.
 *
 * Both directions are covered: focusing while the keyboard is already up (tabbing between
 * fields) scrolls immediately, and a keyboard that opens after focus scrolls on the
 * transition. Nothing happens when the keyboard closes, or for a mouse user on desktop where
 * the inset never leaves `0`.
 */
function useScrollFocusedIntoView(enabled) {
    if (enabled === void 0) { enabled = true; }
    react.useEffect(function () {
        if (!enabled || typeof document === "undefined") {
            return undefined;
        }
        // Seeded from the current value so a hook mounted while the keyboard is already up
        // does not read that as a fresh transition and scroll unbidden.
        var lastInset = readInset();
        var onFocusIn = function (event) {
            if (readInset() > 0) {
                scrollIntoViewIfPossible(event.target);
            }
        };
        var onViewportChange = function () {
            // One frame late: the property is published from a rAF callback, so reading it
            // synchronously here would see the previous value. This assumes the publishing
            // hook mounted first, which it does at both call sites - and even if it did not,
            // a browser fires resize AND scroll for a keyboard, so the second event catches
            // what the first missed.
            window.requestAnimationFrame(function () {
                var inset = readInset();
                var opened = lastInset <= 0 && inset > 0;
                lastInset = inset;
                if (opened) {
                    scrollIntoViewIfPossible(document.activeElement);
                }
            });
        };
        var viewport = typeof window === "undefined" ? undefined : window.visualViewport;
        document.addEventListener("focusin", onFocusIn);
        viewport === null || viewport === void 0 ? void 0 : viewport.addEventListener("resize", onViewportChange);
        viewport === null || viewport === void 0 ? void 0 : viewport.addEventListener("scroll", onViewportChange);
        return function () {
            document.removeEventListener("focusin", onFocusIn);
            viewport === null || viewport === void 0 ? void 0 : viewport.removeEventListener("resize", onViewportChange);
            viewport === null || viewport === void 0 ? void 0 : viewport.removeEventListener("scroll", onViewportChange);
        };
    }, [enabled]);
}

/**
 * A fake soft keyboard, for testing keyboard handling on a machine that has none.
 *
 * **This is a development harness, not a verifier.** It substitutes a stand-in for
 * `window.visualViewport` and fires the events a real browser would, so our own code cannot
 * tell the difference. What it proves is that the hook subscribes, does the arithmetic, and
 * that the consuming CSS responds. What it cannot prove is that a real iOS or Android
 * keyboard produces these events at all — iOS scrolls the visual viewport within the layout
 * viewport, Android may resize the layout viewport itself depending on the host page's
 * viewport meta, and as an embedded widget we do not control that meta. A mock we wrote can
 * only ever confirm our own assumptions.
 *
 * So: use this to iterate on a desktop, and verify on a real device with it switched off,
 * where the same instrumentation reads the numbers the device actually reports.
 *
 * Exported from the package because the Storybook stories that use it live in two different
 * packages, and duplicating a fake this fiddly is how the two copies drift apart.
 */
/**
 * Roughly what the common keyboards occupy.
 *
 * The landscape entry is not optional garnish: a portrait keyboard is ~336px, and a
 * landscape phone viewport is only ~340px tall, so simulating a portrait keyboard sideways
 * leaves 4px of usable space and every layout assertion fails for a reason that has nothing
 * to do with the layout. Landscape keyboards are genuinely shorter.
 */
var KEYBOARD_PRESETS = {
    "iOS (iPhone 14)": 336,
    "Android (Pixel 7)": 312,
    "iOS with autocomplete bar": 380,
    "Compact / numeric": 260,
    "Landscape phone": 200,
};
/**
 * Stands in for VisualViewport. Only the members our code reads are real; the rest satisfy
 * the structural type so this can be assigned over `window.visualViewport`.
 */
var SimulatedViewport = /** @class */ (function () {
    function SimulatedViewport(height, width) {
        this.offsetTop = 0;
        this.offsetLeft = 0;
        this.pageTop = 0;
        this.pageLeft = 0;
        this.scale = 1;
        this.onresize = null;
        this.onscroll = null;
        this.listeners = {};
        this.height = height;
        this.width = width;
    }
    SimulatedViewport.prototype.addEventListener = function (type, listener) {
        var _a;
        ((_a = this.listeners)[type] || (_a[type] = new Set())).add(listener);
    };
    SimulatedViewport.prototype.removeEventListener = function (type, listener) {
        var _a;
        (_a = this.listeners[type]) === null || _a === void 0 ? void 0 : _a.delete(listener);
    };
    SimulatedViewport.prototype.dispatchEvent = function (event) {
        var _a;
        (_a = this.listeners[event.type]) === null || _a === void 0 ? void 0 : _a.forEach(function (listener) { return listener(event); });
        return true;
    };
    SimulatedViewport.prototype.fire = function () {
        // A real browser fires both, and offsetTop only lands on the scroll one.
        this.dispatchEvent(new Event("resize"));
        this.dispatchEvent(new Event("scroll"));
    };
    return SimulatedViewport;
}());
/**
 * Install the simulator, replacing `window.visualViewport` until `destroy()`.
 *
 * The real property is a readonly accessor on `window`, so this redefines it and puts the
 * original descriptor back on teardown. Confined to Storybook — nothing ships with this.
 */
function installKeyboardSimulator() {
    var original = Object.getOwnPropertyDescriptor(window, "visualViewport");
    var layoutHeight = window.innerHeight;
    var simulated = new SimulatedViewport(layoutHeight, window.innerWidth);
    Object.defineProperty(window, "visualViewport", {
        value: simulated,
        writable: true,
        configurable: true,
    });
    return {
        open: function (height) {
            simulated.height = Math.max(0, layoutHeight - height);
            // iOS pushes the visual viewport down within the layout viewport as well as
            // shrinking it. Mirroring that is what makes offsetTop worth reading.
            simulated.offsetTop = height / 2;
            simulated.fire();
        },
        close: function () {
            simulated.height = layoutHeight;
            simulated.offsetTop = 0;
            simulated.fire();
        },
        destroy: function () {
            if (original) {
                Object.defineProperty(window, "visualViewport", original);
            }
            else {
                delete window.visualViewport;
            }
        },
    };
}

/**
 * Wraps a widget story with soft-keyboard instrumentation.
 *
 * Two modes, and the second is the one that matters:
 *
 * 1. **Simulate on** (desktop): substitutes a fake `visualViewport`, so you can raise and
 *    lower a keyboard of a chosen height and watch the layout respond. Good for iterating.
 *    It proves our code reacts correctly to the events; it cannot prove a real keyboard
 *    produces them.
 *
 * 2. **Simulate off** (a real phone): leaves the browser alone. Tap a field, get the real
 *    keyboard, and the readout shows what the device actually reports — which is the number
 *    we have never had. If the fix misbehaves, this is what says why.
 *
 * Defaults to off so that opening the story on a phone does the right thing without anyone
 * having to remember to switch it.
 */
var READOUT_KEYS = [
    ["--xapp-viewport-height", "viewport height"],
    ["--xapp-keyboard-inset", "keyboard inset"],
    ["--xapp-viewport-offset-top", "offset top"],
];
function readMetrics() {
    var viewport = window.visualViewport;
    var style = getComputedStyle(document.documentElement);
    var published = {};
    READOUT_KEYS.forEach(function (_a) {
        var property = _a[0];
        published[property] = style.getPropertyValue(property).trim() || "(unset)";
    });
    return {
        visualHeight: viewport ? Math.round(viewport.height) : undefined,
        layoutHeight: window.innerHeight,
        offsetTop: viewport ? Math.round(viewport.offsetTop) : undefined,
        scale: viewport === null || viewport === void 0 ? void 0 : viewport.scale,
        published: published,
    };
}
var KeyboardTestRig = function (_a) {
    var _b;
    var children = _a.children;
    var _c = react.useState(false), simulate = _c[0], setSimulate = _c[1];
    var _d = react.useState(KEYBOARD_PRESETS["iOS (iPhone 14)"]), height = _d[0], setHeight = _d[1];
    var _e = react.useState(false), open = _e[0], setOpen = _e[1];
    var _f = react.useState(function () { return readMetrics(); }), metrics = _f[0], setMetrics = _f[1];
    var _g = react.useState(), simulator = _g[0], setSimulator = _g[1];
    /**
     * Whether the simulator is actually installed, as opposed to merely requested.
     *
     * The widget subscribes to whatever `window.visualViewport` was when it mounted, so
     * swapping the property under a mounted widget changes nothing — it is still listening
     * to the old object. The children are therefore unmounted while the swap happens and
     * remounted afterwards, against whichever viewport is now current. Found the hard way:
     * without this the toolbar worked, the readout updated, and the layout never moved.
     */
    var _h = react.useState(false), installed = _h[0], setInstalled = _h[1];
    // Poll rather than subscribe: the point is to observe what the page is doing, including
    // any update path we forgot to wire, so this deliberately does not depend on our own
    // event handling being correct.
    react.useEffect(function () {
        var id = window.setInterval(function () { return setMetrics(readMetrics()); }, 100);
        return function () { return window.clearInterval(id); };
    }, []);
    react.useEffect(function () {
        if (!simulate) {
            return undefined;
        }
        var active = installKeyboardSimulator();
        setSimulator(active);
        setInstalled(true);
        return function () {
            active.close();
            active.destroy();
            setSimulator(undefined);
            setInstalled(false);
            setOpen(false);
        };
    }, [simulate]);
    react.useEffect(function () {
        if (!simulator) {
            return;
        }
        if (open) {
            simulator.open(height);
        }
        else {
            simulator.close();
        }
    }, [simulator, open, height]);
    var hasRealViewport = typeof window !== "undefined" && !!window.visualViewport;
    return (jsxRuntime.jsxs("div", { style: { font: "13px/1.5 ui-monospace, SFMono-Regular, Menlo, monospace" }, children: [jsxRuntime.jsxs("div", { style: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 2147483647,
                    background: "#14181a",
                    color: "#edf1f1",
                    padding: "8px 10px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    alignItems: "center",
                }, children: [jsxRuntime.jsxs("label", { style: { display: "flex", gap: 6, alignItems: "center" }, children: [jsxRuntime.jsx("input", { type: "checkbox", checked: simulate, onChange: function (event) { return setSimulate(event.target.checked); } }), "simulate keyboard"] }), jsxRuntime.jsxs("button", { type: "button", disabled: !simulate, onClick: function () { return setOpen(function (value) { return !value; }); }, 
                        // Do not take focus. On a device the keyboard opens *because* a field was
                        // focused, and the field keeps focus throughout. A toolbar button that
                        // steals it makes the interesting case - does the focused field survive
                        // the keyboard arriving? - impossible to reproduce here.
                        onMouseDown: function (event) { return event.preventDefault(); }, style: { padding: "4px 10px" }, children: [open ? "hide" : "show", " keyboard"] }), jsxRuntime.jsx("select", { disabled: !simulate, value: height, onChange: function (event) { return setHeight(Number(event.target.value)); }, children: Object.entries(KEYBOARD_PRESETS).map(function (_a) {
                            var label = _a[0], value = _a[1];
                            return (jsxRuntime.jsxs("option", { value: value, children: [label, " \u2014 ", value, "px"] }, label));
                        }) }), jsxRuntime.jsxs("span", { style: { opacity: 0.75 }, children: ["visual ", (_b = metrics.visualHeight) !== null && _b !== void 0 ? _b : "n/a", " / layout ", metrics.layoutHeight, metrics.offsetTop !== undefined && " / offsetTop ".concat(metrics.offsetTop), metrics.scale !== undefined && " / scale ".concat(metrics.scale.toFixed(2))] }), READOUT_KEYS.map(function (_a) {
                        var property = _a[0], label = _a[1];
                        return (jsxRuntime.jsxs("span", { style: { opacity: 0.75 }, children: [label, ": ", jsxRuntime.jsx("strong", { children: metrics.published[property] })] }, property));
                    }), !hasRealViewport && !simulate && (jsxRuntime.jsx("span", { style: { color: "#d9a45f" }, children: "this browser has no visualViewport \u2014 widgets fall back to 100dvh" }))] }), installed === simulate && (jsxRuntime.jsx("div", { children: children }, simulate ? "simulated" : "real")), simulate && open && (jsxRuntime.jsxs("div", { style: {
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: height,
                    zIndex: 2147483646,
                    background: "repeating-linear-gradient(45deg, #2b3336 0 12px, #222a2b 12px 24px)",
                    color: "#7f8c8e",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderTop: "2px solid #58c4ac",
                }, children: ["simulated keyboard \u2014 ", height, "px"] }))] }));
};

/**
 * Test-lead flag, shared by every widget surface.
 *
 * Studio opens a business's booking page with `?xa_test=1` so the owner can send
 * themselves a test lead. The booking page records that in sessionStorage — never
 * localStorage, so a later real visit is never tagged — and every submission from
 * that page view carries `xaTest: true`. stentor-api keeps such leads out of stats,
 * billing counts, CRM pushes and Google conversions.
 */
/** The booking-page query parameter Studio sets. */
var TEST_LEAD_PARAMETER = "xa_test";
/** The sessionStorage key the booking page writes the flag to. */
var TEST_LEAD_STORAGE_KEY = "xa_test";
/** The attribute sent with a lead submission. */
var TEST_LEAD_ATTRIBUTE = "xaTest";
/** True when the current browser session is a test-lead page view. */
function isTestLeadSession() {
    try {
        return sessionStorage.getItem(TEST_LEAD_STORAGE_KEY) === "1";
    }
    catch (_a) {
        // Storage can be blocked by the browser; treat that as a real visit.
        return false;
    }
}
/**
 * Tags the attributes as a test lead when the session flag is set. A test must
 * never be counted as Google traffic, so any `rwg_token` is dropped as well.
 */
function addTestLeadAttribute(attributes) {
    if (isTestLeadSession()) {
        attributes[TEST_LEAD_ATTRIBUTE] = true;
        delete attributes["rwg_token"];
    }
    return attributes;
}

/**
 * Quicker configurable uuid
 *
 * @export
 * @returns {string}
 */
function uuid() {
    var d = new Date().getTime();
    var newUuid = "xxxxxxxx-xxxx-65xx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        /* tslint:disable:no-magic-numbers */
        /* tslint:disable:no-bitwise */
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        /* tslint:enable:no-magic-numbers */
        /* tslint:disable:no-bitwise */
    });
    return newUuid;
}

exports.AGENT_NOTICE_HIDDEN_ID = AGENT_NOTICE_HIDDEN_ID;
exports.AGENT_NOTICE_ID = AGENT_NOTICE_ID;
exports.AGENT_UA_TOKENS = AGENT_UA_TOKENS;
exports.AI_REFERRAL_PARAMETERS = AI_REFERRAL_PARAMETERS;
exports.ATTRIBUTION_PARAMETERS = ATTRIBUTION_PARAMETERS;
exports.CLICK_ID_PARAMETERS = CLICK_ID_PARAMETERS;
exports.DEFAULT_AGENT_MCP_HOST = DEFAULT_AGENT_MCP_HOST;
exports.DEFAULT_WIDGET_EVENTS_ORIGIN = DEFAULT_WIDGET_EVENTS_ORIGIN;
exports.HomeownerMcpClient = HomeownerMcpClient;
exports.INTERNAL_TRAFFIC_GLOBAL = INTERNAL_TRAFFIC_GLOBAL;
exports.IconButton = IconButton;
exports.KEYBOARD_PRESETS = KEYBOARD_PRESETS;
exports.KeyboardTestRig = KeyboardTestRig;
exports.LOAD_EVENT_PAGE_PARAMETERS = LOAD_EVENT_PAGE_PARAMETERS;
exports.MessageBubble = MessageBubble;
exports.RichInput = RichInput;
exports.RichText = RichText;
exports.SEARCH_CRAWLER_UA_TOKENS = SEARCH_CRAWLER_UA_TOKENS;
exports.SuggestionsGroup = SuggestionsGroup;
exports.SuggestionsGroupHeading = SuggestionsGroupHeading;
exports.SuggestionsItem = SuggestionsItem;
exports.SuggestionsList = SuggestionsList;
exports.TEST_LEAD_ATTRIBUTE = TEST_LEAD_ATTRIBUTE;
exports.TEST_LEAD_PARAMETER = TEST_LEAD_PARAMETER;
exports.TEST_LEAD_STORAGE_KEY = TEST_LEAD_STORAGE_KEY;
exports.UTM_PARAMETERS = UTM_PARAMETERS;
exports.addQueryParametersToURL = addQueryParametersToURL;
exports.addTestLeadAttribute = addTestLeadAttribute;
exports.buildAgentNoticeText = buildAgentNoticeText;
exports.buildLoadEventMetadata = buildLoadEventMetadata;
exports.buildSiteTools = buildSiteTools;
exports.claimPageLoadEvent = claimPageLoadEvent;
exports.detectBrowsingAgent = detectBrowsingAgent;
exports.extendFormat = extendFormat;
exports.extractAttributionFromUrl = extractAttributionFromUrl;
exports.findItemByIndex = findItemByIndex;
exports.findModelContext = findModelContext;
exports.getAttribution = getAttribution;
exports.getItemsLength = getItemsLength;
exports.getStoredAttribution = getStoredAttribution;
exports.injectMcpDiscoveryTags = injectMcpDiscoveryTags;
exports.installKeyboardSimulator = installKeyboardSimulator;
exports.isTestLeadSession = isTestLeadSession;
exports.lockBodyScroll = lockBodyScroll;
exports.parseSuggestionsResponse = parseSuggestionsResponse;
exports.readInternalTrafficMark = readInternalTrafficMark;
exports.registerSiteTools = registerSiteTools;
exports.renderAgentNotice = renderAgentNotice;
exports.resolveAgentMcpEndpoints = resolveAgentMcpEndpoints;
exports.resolveWidgetEventsUrl = resolveWidgetEventsUrl;
exports.sendWidgetLoadEvent = sendWidgetLoadEvent;
exports.sortSuggestionItems = sortSuggestionItems;
exports.startAgentDiscovery = startAgentDiscovery;
exports.storeAttribution = storeAttribution;
exports.stripQueryString = stripQueryString;
exports.trackVisualViewport = trackVisualViewport;
exports.useBodyScrollLock = useBodyScrollLock;
exports.useJsonFetch = useJsonFetch;
exports.useScrollFocusedIntoView = useScrollFocusedIntoView;
exports.useSuggestionsFetch = useSuggestionsFetch;
exports.useVisualViewportProperties = useVisualViewportProperties;
exports.uuid = uuid;
//# sourceMappingURL=index.js.map
